import { createSlice } from "@reduxjs/toolkit";
import { createUserApis, updatePasswordApis, updateUserWorkStatusApis, usersApis } from "./userActions";

const initialState = {
  userData: [],
  status: "idle",
  createStatus: "idle",          // Added explicit initial state
  updatePasswordStatus: "idle",  // Added explicit initial state
  updateWorkStatusStatus: "idle",
  error: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    logout(state) {
      return initialState; // Reset to initial state on logout
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users List
      .addCase(usersApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(usersApis.fulfilled, (state, action) => {
            console.log("Redux Payload", action.payload);
        state.status = "succeeded";
        state.userData = action.payload.data;
      })
      .addCase(usersApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })

      // Create User
      .addCase(createUserApis.pending, (state) => {
        state.createStatus = "loading";
        state.error = null;
      })
      .addCase(createUserApis.fulfilled, (state) => {
        state.createStatus = "succeeded"; // Fixed from createData to createStatus
      })
      .addCase(createUserApis.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.payload;
      })

      // Update Password
      .addCase(updatePasswordApis.pending, (state) => {
        state.updatePasswordStatus = "loading";
        state.error = null;
      })
      .addCase(updatePasswordApis.fulfilled, (state) => {
        state.updatePasswordStatus = "succeeded"; // Fixed from updatePasswordData
      })
      .addCase(updatePasswordApis.rejected, (state, action) => {
        state.updatePasswordStatus = "failed";
        state.error = action.payload;
      })
      .addCase(updateUserWorkStatusApis.pending, (state) => {
        state.updateWorkStatusStatus = "loading";
        state.error = null;
      })
      .addCase(updateUserWorkStatusApis.fulfilled, (state) => {
        state.updateWorkStatusStatus = "succeeded";
      })
      .addCase(updateUserWorkStatusApis.rejected, (state, action) => {
        state.updateWorkStatusStatus = "failed";
        state.error = action.payload;
      });
  },
});

export const { logout } = usersSlice.actions;
export default usersSlice.reducer;